'use strict';

import {
	RESET_STATE,
	SET_INGREDIENT_VARIANT_OPTIONS,
	UPDATE_INGREDIENT_VARIANT_OPTIONS
} from './ingredientVariantOptions.actions';

const defaultState = {
	data: {
		ingredientVariantOptions: {}
	}
};

function reducer(state = defaultState, action) {
	const { payload, type } = action;

	switch (type) {
	case SET_INGREDIENT_VARIANT_OPTIONS: {
		return {
			...state,
			data: {
				...state.data,
				ingredientVariantOptions: payload
			}
		};
	}

	case UPDATE_INGREDIENT_VARIANT_OPTIONS: {
		return {
			...state,
			data: {
				...state.data,
				ingredientVariantOptions: {
					...state.data.ingredientVariantOptions,
					...payload
				}
			}
		};
	}

	case RESET_STATE: {
		return defaultState;
	}

	default:
		// never return default state in default case, Filip!!!
		return state;
	}
}

export default reducer;
